import React, { useState, useEffect } from 'react';
import { FaSearch } from 'react-icons/fa';
import LoadingSpinner from '../common/LoadingSpinner';

const ClickHistory = () => {
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeFilter, setActiveFilter] = useState('all'); // 'all', 'defaut', 'personnalise'
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const fetchHistory = async () => {
            setLoading(true);
            setError(null);
            const token = localStorage.getItem('authToken');
            if (!token) {
                setError("Authentification requise.");
                setLoading(false);
                return;
            }

            try {
                const response = await fetch('https://back-desalpe.onrender.com/api/click-events/history', {
                    headers: { 'Authorization': `Bearer ${token}` }
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch click history');
                }
                const data = await response.json();
                setHistory(data);
            } catch (err) {
                setError("Impossible de charger l'historique des clics.");
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchHistory();
    }, []);

    const filteredHistory = history
        .filter(item => {
            if (activeFilter === 'all') return true;
            return item.link_type === activeFilter;
        })
        .filter(item => {
            const fullName = `${item.ambassador_firstname || ''} ${item.ambassador_lastname || ''}`.toLowerCase();
            return fullName.includes(searchTerm.toLowerCase());
        });

    if (loading) {
        return <LoadingSpinner />;
    }

    if (error) {
        return <div className="error-message">{error}</div>;
    }

    return (
        <div className="stats-container">
            <div className="filter-bar">
                <div className="search-bar" style={{ flexGrow: 2 }}>
                    <FaSearch />
                    <input
                        type="text"
                        placeholder="Rechercher par nom d'ambassadeur..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
                <span>Filtrer par type:</span>
                <button onClick={() => setActiveFilter('all')} className={activeFilter === 'all' ? 'active' : ''}>Tous</button>
                <button onClick={() => setActiveFilter('defaut')} className={activeFilter === 'defaut' ? 'active' : ''}>Défaut</button>
                <button onClick={() => setActiveFilter('personnalise')} className={activeFilter === 'personnalise' ? 'active' : ''}>Personnalisé</button>
            </div>
            <div className="links-table-container">
                <table>
                    <thead>
                        <tr>
                            <th>Prénom</th>
                            <th>Nom</th>
                            <th>Email Associé</th>
                            <th>Lien Cliqué</th>
                            <th>Type</th>
                            <th>Date et Heure du Clic</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredHistory.map(item => (
                            <tr key={item.id}>
                                <td>{item.ambassador_firstname || 'N/A'}</td>
                                <td>{item.ambassador_lastname || 'N/A'}</td>
                                <td>{item.ambassador_email || 'N/A'}</td>
                                <td>{item.link_url || 'N/A'}</td>
                                <td>{item.link_type === 'defaut' ? 'Défaut' : 'Personnalisé'}</td>
                                <td>{new Date(item.date).toLocaleString('fr-FR')}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ClickHistory;

